import { lazy } from "react";
import { meritoImport } from "../mpr_2026_10/meritoImport";

export const sections = [
  {
    id: "beneficiaries",
    title: "Projeto e Beneficiário",
    component: lazy(() => import("../mpr_2026_10/01_Beneficiaries")),
  },
  {
    id: "stepFraming",
    title: "Enquadramento STEP",
    component: lazy(() => import("./02_StepFraming")),
  },
  {
    id: "economic",
    title: "Unidade Económica",
    component: lazy(() => import("../mpr_2026_10/04_EconomicUnit")),
  },
  {
    id: "marketAnalysis",
    title: "Análise Mercado",
    component: lazy(() => import("../mpr_2026_10/05_MarketAnalysis")),
  },
  {
    id: "balance",
    title: "Balanço e DR",
    component: lazy(() => import("../mpr_2026_10/06_BalanceDR")),
  },
  {
    id: "project",
    title: "Dados do Projeto",
    component: lazy(() => import("../mpr_2026_10/07_ProjectData")),
  },
  {
    id: "actions",
    title: "Tipologias",
    component: lazy(() => import("../mpr_2026_10/10_Actions")),
  },
  {
    id: "activities",
    title: "Atividades e Indicadores",
    component: lazy(() => import("../mpr_2026_10/11_Activities")),
  },
  { id: "costs", title: "Custos", component: lazy(() => import("../mpr_2026_10/15_Costs")) },
  {
    id: "operationDescription",
    title: "Descrição da Operação",
    component: lazy(() => import("../mpr_2026_10/09_OperationDescription")),
  },
  {
    id: "financing",
    title: "Financiamento",
    component: lazy(() => import("../mpr_2026_10/17_Financing")),
  },
  {
    id: "selectionCriteria",
    title: "Critérios de Seleção",
    component: lazy(() => import("./18_SelectionCriteria")),
  },
  {
    id: "declarations",
    title: "Declarações",
    component: lazy(() => import("../mpr_2026_10/19_Declarations")),
  },
];

// Mérito file: the MPr-2026-6 one (see ./meritoImport.js).
export const importFiles = { Mérito: meritoImport };
